import styles from "../pages/styles/SidebarFeaturesPage.module.scss";
import classNames from "classnames";
import moment from "moment";

const newTagDateFormat = "M-D-YYYY";

export default function NewTag(props: {
  className?: string;
  createdAt: string;
}) {
  const newTagClassName = classNames({
    [styles.tag]: true,
    [props.className || ""]: props.className,
  });

  if (
    moment().isAfter(moment(props.createdAt, newTagDateFormat).add(3, "months"))
  ) {
    return <></>;
  }

  return <span className={newTagClassName}>NEW</span>;
}
